export default function() {}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-shape/src/noop.js
// module id = 50
// module chunks = 0 1 2 3 4